import { API, graphqlOperation } from 'aws-amplify'
import { put, call } from 'redux-saga/effects'
import { ERROR_MESSAGES } from '@wellbeingxltd/fe-lib/constants'
import { submitToApi } from 'awsApi'
import { GetSupplierTransactionsAndResources, UpdateSupplierTransaction } from '@wellbeingxltd/fe-lib/api/graphql'
import TransactionsActions from 'store/models/transactions'
import { URL } from './endpoints'

export function* getTransactions({ supplierId, nextTokenT, nextTokenR }) {
    try {
        const cognitoUser = JSON.parse(localStorage.getItem('cognitoUser'))
        const customType = cognitoUser.attributes['custom:type'] === 'supplier-admin' ? 'supplier-admin' : null
        const response = yield call(() =>
            API.graphql(
                graphqlOperation(GetSupplierTransactionsAndResources, {
                    supplierId,
                    nextTokenT,
                    nextTokenR,
                    ...(customType && { userType: customType }),
                })
            )
        )
        console.log('getTransactions response: ', response)
        yield put(
            TransactionsActions.getTransactionsSuccess(
                response.data.getSupplierDetails.transactions.items,
                response.data.getSupplierDetails.resources.items,
                response.data.getSupplierDetails.transactions.nextToken
            )
        )
        if (response.data.getSupplierDetails.transactions.nextToken || response.data.getSupplierDetails.resources.nextToken) {
            yield call(getTransactions, {
                supplierId,
                nextTokenT: response.data.getSupplierDetails.transactions.nextToken,
                nextTokenR: response.data.getSupplierDetails.resources.nextToken,
            })
        }
    } catch (error) {
        console.log('get transactions error: ', error)
        const errorMessage = error?.errors?.[0]?.message || ERROR_MESSAGES.default
        yield put(TransactionsActions.getTransactionsFailure(errorMessage))
    }
}

export function* updateTransaction({ state, transaction, history }) {
    let objectToSend = {}

    const { userId, transactionId, deliveryCompany, deliveryTrackingNumber } = transaction

    switch (state) {
        case 'PENDING':
            objectToSend = { userId, transactionId, state, deliveryCompany, deliveryTrackingNumber }
            break
        case 'CONFIRMED':
            let dateOfConfirmation = JSON.stringify(new Date())
            dateOfConfirmation = dateOfConfirmation.substring(1, dateOfConfirmation.length - 3)
            objectToSend = { userId, transactionId, state, deliveryCompany, deliveryTrackingNumber, dateOfConfirmation }
            break
        default:
            break
    }
    try {
        const response = yield call(() =>
            API.graphql(
                graphqlOperation(UpdateSupplierTransaction, {
                    input: {
                        ...objectToSend,
                    },
                })
            )
        )
        history.replace('/transactions')
        console.log('updateTransaction response: ', response)
        yield put(TransactionsActions.updateTransactionSuccess(response.data.updateTransactionDetails))
    } catch (error) {
        console.log('updateTransaction error: ', error)
        yield put(TransactionsActions.updateTransactionFailure())
    }
}

export function* askForHelp({ answers, transaction, callback }) {
    try {
        const { message } = yield call(() =>
            submitToApi({
                body: { answers, transaction },
                method: 'POST',
                path: URL.EMAIL_SUPPORT.V2_EMAILSUPPORT_USER_OPENTICKET,
                query: { from: 'supplier' },
                url: URL.EMAIL_SUPPORT.BASE,
            })
        )
        yield put(TransactionsActions.askForHelpSuccess())
        callback(message, 'success')
    } catch (error) {
        yield put(TransactionsActions.askForHelpFailure(error))
        callback(error, 'error')
    }
}

export function* cancelOrder({ body, callback }) {
    const { supplierId = '' } = JSON.parse(localStorage.getItem('supplier'))
    try {
        const { message } = yield call(() =>
            submitToApi({
                body: { ...body, supplierId },
                method: 'POST',
                path: URL.SUPPLIERS.V3_SUPPLIERS_SUPPLIER_CANCEL_TRANSACTION,
                url: URL.SUPPLIERS.BASE,
            })
        )
        yield put(TransactionsActions.cancelOrderSuccess(body.transactionId))
        callback(message, 'success')
    } catch (error) {
        yield put(TransactionsActions.cancelOrderFailure())
        callback(error, 'error')
    }
}
